import React from 'react';
import withSizes from 'react-sizes';

import {
  LinkOutSVG,
  RollUpClickableTitle,
  WrapBannerImageWithHref,
} from '../../../../shared';

const mapSizesToProps = ({ width }) => ({
  winW: width
})

class KISFF12 extends React.Component {
  bannerImgSrc() {
    return this.props.winW >= 1024
      ? '/img/2024/01/AttendanceRules/dt.png'
      : '/img/2024/01/AttendanceRules/mob.png'
  }

  promoLink = process.env.REACT_APP_PDF_PATH_TO_ATTENDANCE_RULES

  render() {
    const accentColor = '#73233c';

    return (
      <div className='mp__sertificat'>
        <div className='wd'>
          <div className='sertificat'>
            <WrapBannerImageWithHref href={this.promoLink} src={this.bannerImgSrc()} />
            <RollUpClickableTitle title='ОЗНАЙОМИТИСЯ' />

            <div className='sertificat__text'>
              <div>
                <p className='sertificat__text__paragraph'>
                  <a target="_blank" href={this.promoLink} style={{
                    color: accentColor,
                    fontWeight: '700',
                    display: 'inline-flex',
                    alignItems: 'center'
                  }}>Правила відвідування кінотеатру «Жовтень»<LinkOutSVG color={accentColor} /></a>,
                  які затверджені директором ТОВ «Кіноман» від «01» жовтня 2025 року.
                </p>

                <p className='sertificat__text__paragraph'>
                  Щоб ознайомитися з правилами кінотеатру натисніть на банер вище або перейдіть за <a target="_blank" href={this.promoLink} style={{
                    color: accentColor,
                    fontWeight: '700',
                    display: 'inline-flex',
                    alignItems: 'center'
                  }}>посиланням<LinkOutSVG color={accentColor} /></a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default withSizes(mapSizesToProps)(KISFF12)


// WEBPACK FOOTER //
// ./src/components/snippets/ChiefSliderComponent/entities/items/AttendanceRules/impl/AttendanceRules.jsx